import BenefitsSection from "../components/BenefitsSection";
import CasinoComparison from "../components/CasinoComparison";
import ComparisonSection from "../components/ComparisonSection";
import FaqSection from "../components/FaqSection";
import Footer from "../components/Footer";
import HeroSection from "../components/HeroSection";
import Navigation from "../components/Navigation";
import ReadyToPlayActionSection from "../components/ReadyToPlayActionSection";

const HomePage = () => {
  return (
    <div className="home wp-singular page-template page-template-elementor_theme page page-id-3193 wp-custom-logo wp-embed-responsive wp-theme-hello-elementor theme-default elementor-default elementor-kit-3179 elementor-page elementor-page-3193">
      <Navigation />
      <main id="content" className="site-main post-3193 page type-page status-publish hentry">
        <div className="page-content">
          <div data-elementor-type="wp-post" data-elementor-id="3193" className="elementor elementor-3193"
            data-elementor-post-type="page">
            <HeroSection />
            <CasinoComparison />
            <BenefitsSection />
            <ReadyToPlayActionSection />
            <ComparisonSection />
            <FaqSection />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;


